export const activitySessionfilters = {
  activity_type: {
    fieldPath: 'activity_type',
    fieldReadPath: 'activity_type',
    name: 'activity_type',
    label: 'activities.activity.activity_type.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.activity.camp_label',
        value: 'camp',
        description: 'global.activity.camp.description',
      },
      {
        text: 'global.activity.course_label',
        value: 'course',
        description: 'global.activity.course.description',
      },
      {
        text: 'global.activity.session_label',
        value: 'session',
        description: 'global.activity.session.description',
      },
      {
        text: 'global.activity.training_label',
        value: 'training',
        description: 'global.activity.training.description',
      },
      {
        text: 'global.activity.competition_label',
        value: 'competition',
        description: 'global.activity.competition.description',
      },
    ],
    id: 'activities-activity__activity-type',
    veeValidation: true,
    rules: [],
    tags: [],
    fieldAttributes: [],
    fieldClass: 'activities-activity__activity-type--input',
    showError: true,
    errorClass: 'activities-activity__activity-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__activity-type--input-help',
    helpAttributes: [],
    help: 'activities.activity.activity_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__activity-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.activity_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__activity-type--input-label',
    labelAttributes: {
      for: 'activities-activity__activity-type',
      cols: 12,
      'sr-only': false,
      align: 'left',
      size: 'md',
    },
    wrapperAttributes: {
      class: {
        'pl-0 pr-2': true,
      },
    },
    placeholder: '',
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'activities.activity_session.status.label',
    options: [
      {
        text: 'selects.resource.status.active',
        value: 'active',
      },
      {
        text: 'selects.resource.status.inactive',
        value: 'inactive',
      },
      {
        text: 'selects.resource.status.trash',
        value: 'trash',
      },
    ],
    id: 'activities-activity-session__status',

    rules: [],
    fieldAttributes: [],
    fieldClass: 'activities-activity-session__status--input',
    errorClass: 'activities-activity-session__status--input-error',
    errorAttributes: [],
    helpClass: 'activities-activity-session__status--input-help',
    helpAttributes: [],
    help: 'activities.activity_session.status.help',
    feedbackClass: 'activities-activity-session__status--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_session.status.feedback',
    labelClass: 'activities-activity-session__status--input-label',
    placeholder: 'activities.activity.status.label',
  },
  activity_id: {
    fieldPath: 'activity_id',
    fieldReadPath: 'activity_id',
    name: 'activity_id',
    label: 'activities.activity_session.activity_id.label',
    options: [],
    id: 'activities-activity-session__activity-id',
    rules: [],
    fieldAttributes: [],
    fieldClass: 'activities-activity-session__activity-id--input',
    errorClass: 'activities-activity-session__activity-id--input-error',
    errorAttributes: [],
    helpClass: 'activities-activity-session__activity-id--input-help',
    helpAttributes: [],
    help: 'activities.activity_session.activity_id.help',
    feedbackClass: 'activities-activity-session__activity-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_session.activity_id.feedback',
    labelClass: 'activities-activity-session__activity-id--input-label',
    placeholder: 'activities.activity_group.activity.label',
    selectLabel: 'name',
    selectEntity: 'bpc-activity',
    selectValue: 'id',
    selectMultiple: false,
  },
  date: {
    fieldPath: 'date',
    fieldReadPath: 'date',
    name: 'date',
    label: 'activities.activity_session.date.label',
    inputType: 'datepicker',
    id: 'activities-activity-session__date',
    rules: [],
    fieldAttributes: [],
    fieldClass: 'activities-activity-session__date--input',
    errorClass: 'activities-activity-session__date--input-error',
    errorAttributes: [],
    helpClass: 'activities-activity-session__date--input-help',
    helpAttributes: [],
    help: 'activities.activity_session.date.help',
    feedbackClass: 'activities-activity-session__date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_session.date.feedback',
    labelClass: 'activities-activity-session__date--input-label',
    placeholder: 'date',
  },
  responsible_ids: {
    fieldPath: 'responsible_ids',
    fieldReadPath: 'responsible_ids',
    name: 'responsible_ids',
    label: 'activities.activity_session.responsible_ids.label',
    id: 'activities-activity-session__responsible-ids',
    rules: [],
    fieldAttributes: [],
    fieldClass: 'activities-activity-session__responsible-ids--input',
    errorClass: 'activities-activity-session__responsible-ids--input-error',
    errorAttributes: [],
    helpClass: 'activities-activity-session__responsible-ids--input-help',
    helpAttributes: [],
    help: 'activities.activity_session.responsible_ids.help',
    feedbackClass: 'activities-activity-session__responsible-ids--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_session.responsible_ids.feedback',
    labelClass: 'activities-activity-session__responsible-ids--input-label',
    placeholder: 'activities.activity_session.responsible.label',
    selectValue: 'id',
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectMultiple: true,
  },
  team_id: {
    fieldPath: 'team_id',
    fieldReadPath: 'team_id',
    name: 'team_id',
    label: 'activities.activity_session.team_id.label',
    id: 'activities-activity-session__team_id',
    rules: [],
    fieldAttributes: [],
    fieldClass: 'activities-activity-session__team_id--input',
    errorClass: 'activities-activity-session__team_id--input-error',
    errorAttributes: [],
    helpClass: 'activities-activity-session__team_id--input-help',
    helpAttributes: [],
    help: 'activities.activity_session.team_id.help',
    feedbackClass: 'activities-activity-session__team_id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_session.team_id.feedback',
    labelClass: 'activities-activity-session__team_id--input-label',
    placeholder: 'activities.activity_session.team.label',
    selectValue: 'id',
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectMultiple: false,
  },
};
export const activityFilters = {
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'activities.activity.status.label',
    options: [
      {
        text: 'selects.resource.status.active',
        value: 'active',
      },
      {
        text: 'selects.resource.status.inactive',
        value: 'inactive',
      },
      {
        text: 'selects.resource.status.trash',
        value: 'trash',
      },
    ],
    fieldClass: 'activities-activity__status--input',
    showLabel: false,
    labelAttributes: {
      for: 'activities-activity__status',
    },
    placeholder: 'activities.activity.status.label',
  },
  activity_type: {
    fieldPath: 'activity_type',
    fieldReadPath: 'activity_type',
    name: 'activity_type',
    label: 'activities.activity.activity_type.label',
    options: [
      {
        text: 'global.activity.camp_label',
        value: 'camp',
        description: 'global.activity.camp.description',
      },
      {
        text: 'global.activity.course',
        value: 'course',
        description: 'global.activity.course.description',
      },
      {
        text: 'global.activity.session',
        value: 'session',
        description: 'global.activity.session.description',
      },
      {
        text: 'global.activity.training',
        value: 'training',
        description: 'global.activity.training.description',
      },
      {
        text: 'global.activity.competition_label',
        value: 'competition',
        description: 'global.activity.competition.description',
      },
      {
        text: 'global.activity.learning_label',
        value: 'learning',
        description: 'global.activity.learning.description',
      },
      {
        text: 'global.activity.exam',
        value: 'exam',
        description: 'global.activity.exam.description',
      },
    ],
    labelAttributes: {
      for: 'activities-activity__activity-type',
    },
    fieldClass: 'activities-activity__activity-type--input',
    showLabel: false,
    placeholder: 'activities.activity.activity_type.placeholder',
  },
  period: {
    fieldPath: 'period',
    fieldReadPath: 'period',
    name: 'period',
    label: 'activities.activity.period.label',
    options: [
      {
        text: 'activities.activity.period.past',
        value: 'past',
      },
      {
        text: 'activities.activity.period.ongoing',
        value: 'ongoing',
      },
      {
        text: 'activities.activity.period.ongoing_upcoming',
        value: 'ongoing_upcoming',
      },
      {
        text: 'activities.activity.period.upcoming',
        value: 'upcoming',
      },
    ],
    labelAttributes: {
      for: 'activities-activity__period',
    },
    fieldClass: 'activities-activity__period--input',
    showLabel: false,
    placeholder: 'activities.activity.period.placeholder',
  },
};

export const activityFields = {
  id: {
    fieldPath: 'id',
    errorFieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
    label: 'activities.activity.id.label',
    inputType: 'input',
    id: 'activities-activity__id',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'activities-activity__id--input',
    showError: true,
    errorClass: 'activities-activity__id--input-error',
    errorAttributes: [],
    showFeedback: true,
    feedbackClass: 'activities-activity__id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__id--input-label',
    labelAttributes: {
      for: 'activities-activity__id',
    },
  },
  center_id: {
    fieldPath: 'center_id',
    errorFieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
    label: 'activities.activity.center_id.label',
    id: 'activities-activity__center-id',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'activities-activity__center-id--input',
    showError: true,
    errorClass: 'activities-activity__center-id--input-error',
    errorAttributes: [],
    showFeedback: true,
    feedbackClass: 'activities-activity__center-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.center_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__center-id--input-label',
    labelAttributes: {
      for: 'activities-activity__center-id',
    },
  },
  code: {
    fieldPath: 'code',
    errorFieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'activities.activity.code.label',
    id: 'activities-activity__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    fieldClass: 'activities-activity__code--input',
    showError: true,
    errorClass: 'activities-activity__code--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__code--input-help',
    helpAttributes: [],
    help: 'activities.activity.code.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__code--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.code.feedback',
    showLabel: true,
    labelClass: 'activities-activity__code--input-label',
    labelAttributes: {
      for: 'activities-activity__code',
    },
  },
  status: {
    fieldPath: 'status',
    errorFieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'activities.activity.status.label',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
    ],
    id: 'activities-activity__status',
    veeValidation: true,
    rules: ['required', 'in:active,inactive'],
    warningRules: [],
    fieldClass: 'activities-activity__status--input',
    showError: true,
    errorClass: 'activities-activity__status--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__status--input-help',
    helpAttributes: [],
    help: 'activities.activity.status.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__status--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.status.feedback',
    showLabel: true,
    labelClass: 'activities-activity__status--input-label',
    labelAttributes: {
      for: 'activities-activity__status',
    },
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'inactive',
        color: 'border-0 text-white bg-danger',
      },
    ],
  },
  activity_type: {
    fieldPath: 'activity_type',
    errorFieldPath: 'activity_type',
    fieldReadPath: 'activity_type',
    name: 'activity_type',
    label: 'activities.activity.activity_type.label',
    options: [
      {
        text: 'global.activity.camp_label',
        value: 'camp',
        description: 'global.activity.camp.description',
      },
      {
        text: 'global.activity.course',
        value: 'course',
        description: 'global.activity.course.description',
      },
      {
        text: 'global.activity.session',
        value: 'session',
        description: 'global.activity.session.description',
      },
      {
        text: 'global.activity.training',
        value: 'training',
        description: 'global.activity.training.description',
      },
      {
        text: 'global.activity.competition_label',
        value: 'competition',
        description: 'global.activity.competition.description',
      },
      {
        text: 'global.activity.learning_label',
        value: 'learning',
        description: 'global.activity.learning.description',
      },
      {
        text: 'global.activity.exam',
        value: 'exam',
        description: 'global.activity.exam.description',
      },
    ],
    id: 'activities-activity__activity-type',
    veeValidation: true,
    rules: ['required', 'in:camp,course,session,training,competition,learning,exam'],
    warningRules: [],
    fieldClass: 'activities-activity__activity-type--input',
    showError: true,
    errorClass: 'activities-activity__activity-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__activity-type--input-help',
    helpAttributes: [],
    help: 'activities.activity.activity_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__activity-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.activity_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__activity-type--input-label',
    labelAttributes: {
      for: 'activities-activity__activity-type',
    },
  },
  name: {
    fieldPath: 'name',
    errorFieldPath: 'name',
    fieldReadPath: 'name',
    name: 'name',
    label: 'activities.activity.name.label',
    id: 'activities-activity__name',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'activities-activity__name--input',
    showError: true,
    errorClass: 'activities-activity__name--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__name--input-help',
    helpAttributes: [],
    help: 'activities.activity.name.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__name--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.name.feedback',
    showLabel: true,
    labelClass: 'activities-activity__name--input-label',
    labelAttributes: {
      for: 'activities-activity__name',
    },
  },
  contact_id: {
    fieldPath: 'contact_id',
    errorFieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'activities.activity.contact_id.label',
    id: 'activities-activity__contact-id',
    veeValidation: true,
    rules: ['nullable', 'exists:contacts,id'],
    warningRules: [],
    fieldClass: 'activities-activity__contact-id--input',
    showError: true,
    errorClass: 'activities-activity__contact-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__contact-id--input-help',
    helpAttributes: [],
    help: 'activities.activity.contact_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__contact-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.contact_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__contact-id--input-label',
    labelAttributes: {
      for: 'activities-activity__contact-id',
    },
  },
  contact: {
    fieldPath: 'contact',
    errorFieldPath: 'contact',
    fieldReadPath: 'contact',
    name: 'contact',
    label: 'activities.activity.contact.label',
    id: 'activities-activity__contact',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__contact--input',
    showError: true,
    errorClass: 'activities-activity__contact--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__contact--input-help',
    helpAttributes: [],
    help: 'activities.activity.contact.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__contact--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.contact.feedback',
    showLabel: true,
    labelClass: 'activities-activity__contact--input-label',
    labelAttributes: {
      for: 'activities-activity__contact',
    },
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectMultiple: false,
    withTableSearch: false,
    displayConfigName: 'search',
    withNew: false,
    formConfigName: 'quick-create',
    filters: [
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
    ],
  },
  team_id: {
    fieldPath: 'team_id',
    errorFieldPath: 'team_id',
    fieldReadPath: 'team_id',
    name: 'team_id',
    label: 'activities.activity.team_id.label',
    id: 'activities-activity__team-id',
    veeValidation: true,
    rules: ['nullable', 'exists:contacts,id'],
    warningRules: [],
    fieldClass: 'activities-activity__team-id--input',
    showError: true,
    errorClass: 'activities-activity__team-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__team-id--input-help',
    helpAttributes: [],
    help: 'activities.activity.team_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__team-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.team_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__team-id--input-label',
    labelAttributes: {
      for: 'activities-activity__team-id',
    },
  },
  team: {
    fieldPath: 'team',
    errorFieldPath: 'team',
    fieldReadPath: 'team',
    name: 'team',
    label: 'activities.activity.team.label',
    id: 'activities-activity__team',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__team--input',
    showError: true,
    errorClass: 'activities-activity__team--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__team--input-help',
    helpAttributes: [],
    help: 'activities.activity.team.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__team--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.team.feedback',
    showLabel: true,
    labelClass: 'activities-activity__team--input-label',
    labelAttributes: {
      for: 'activities-activity__team',
    },
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectMultiple: false,
    withTableSearch: false,
    displayConfigName: 'search',
    withNew: false,
    formConfigName: 'quick-create',
    filters: [
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
      {
        filterField: 'type',
        modelField: null,
        value: ['team'],
      },
    ],
  },
  posts: {
    fieldPath: 'posts',
    errorFieldPath: 'posts',
    fieldReadPath: 'posts',
    name: 'posts',
    label: 'activities.activity.posts.label',
    id: 'activities-activity__posts',
    veeValidation: true,
    rules: ['nullable', 'array'],
    warningRules: [],
    fieldClass: 'activities-activity__posts--input',
    showError: true,
    errorClass: 'activities-activity__posts--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__posts--input-help',
    helpAttributes: [],
    help: 'activities.activity.posts.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__posts--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.posts.feedback',
    showLabel: true,
    labelClass: 'activities-activity__posts--input-label',
    labelAttributes: {
      for: 'activities-activity__posts',
    },
    selectLabel: 'title',
    selectEntity: 'post',
    selectMultiple: true,
    withTableSearch: true,
    displayConfigName: 'search',
    withNew: true,
    formConfigName: 'default',
  },
  certificate_categories: {
    fieldPath: 'certificate_categories',
    errorFieldPath: 'certificate_categories',
    fieldReadPath: 'certificate_categories',
    name: 'certificate_categories',
    label: 'activities.activity.certificate_categories.label',
    id: 'activities-activity__certificate-categories',
    veeValidation: true,
    rules: ['nullable', 'array'],
    warningRules: [],
    fieldClass: 'activities-activity__certificate-categories--input',
    showError: true,
    errorClass: 'activities-activity__certificate-categories--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__certificate-categories--input-help',
    helpAttributes: [],
    help: 'activities.activity.certificate_categories.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__certificate-categories--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.certificate_categories.feedback',
    showLabel: true,
    labelClass: 'activities-activity__certificate-categories--input-label',
    labelAttributes: {
      for: 'activities-activity__certificate-categories',
    },
    selectLabel: 'name',
    selectEntity: 'certificate-category',
    selectMultiple: true,
    withTableSearch: true,
    displayConfigName: 'search',
    withNew: true,
    formConfigName: 'default',
  },
  subscriptionCategories: {
    fieldPath: 'subscriptionCategories',
    errorFieldPath: 'subscriptionCategories',
    fieldReadPath: 'subscription_categories',
    name: 'subscriptionCategories',
    label: 'activities.activity.subscription_categories.label',
    id: 'activities-activity__subscription-categories',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__subscription-categories--input',
    showError: true,
    errorClass: 'activities-activity__subscription-categories--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__subscription-categories--input-help',
    helpAttributes: [],
    help: 'activities.activity.subscription_categories.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__subscription-categories--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.subscription_categories.feedback',
    showLabel: true,
    labelClass: 'activities-activity__subscription-categories--input-label',
    labelAttributes: {
      for: 'activities-activity__subscription-categories',
    },
    selectLabel: 'name',
    selectEntity: 'subscription-category',
    selectMultiple: true,
    withTableSearch: true,
    displayConfigName: 'search',
    filterConfigName: 'active',
    withNew: false,
    formConfigName: 'quick-create-from-activity',
    filters: [
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
    ],
  },
  allow_multiple_enrollment: {
    fieldPath: 'allow_multiple_enrollment',
    errorFieldPath: 'allow_multiple_enrollment',
    fieldReadPath: 'allow_multiple_enrollment',
    name: 'allow_multiple_enrollment',
    label: 'activities.activity.allow_multiple_enrollment.label',
    id: 'activities-activity__allow-multiple-enrollment',
    veeValidation: true,
    rules: ['boolean'],
    warningRules: [],
    fieldClass: 'activities-activity__allow-multiple-enrollment--input',
    showError: true,
    errorClass: 'activities-activity__allow-multiple-enrollment--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__allow-multiple-enrollment--input-help',
    helpAttributes: [],
    help: 'activities.activity.allow_multiple_enrollment.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__allow-multiple-enrollment--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.allow_multiple_enrollment.feedback',
    showLabel: true,
    labelClass: 'activities-activity__allow-multiple-enrollment--input-label',
    labelAttributes: {
      for: 'activities-activity__allow-multiple-enrollment',
    },
  },
  option_group_id: {
    fieldPath: 'option_group_id',
    errorFieldPath: 'option_group_id',
    fieldReadPath: 'option_group_id',
    name: 'option_group_id',
    label: 'activities.activity.option_group_id.label',
    id: 'activities-activity__option-group-id',
    veeValidation: true,
    rules: ['nullable', 'exists:option_groups,id'],
    warningRules: [],
    fieldClass: 'activities-activity__option-group-id--input',
    showError: true,
    errorClass: 'activities-activity__option-group-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__option-group-id--input-help',
    helpAttributes: [],
    help: 'activities.activity.option_group_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__option-group-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.option_group_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__option-group-id--input-label',
    labelAttributes: {
      for: 'activities-activity__option-group-id',
    },
  },
  optionGroup: {
    fieldPath: 'optionGroup',
    errorFieldPath: 'optionGroup',
    fieldReadPath: 'option_group',
    name: 'optionGroup',
    label: 'global.option_group.label',
    id: 'activities-activity__option-group',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__option-group--input',
    showError: true,
    errorClass: 'activities-activity__option-group--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__option-group--input-help',
    helpAttributes: [],
    help: 'activities.activity.option_group.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__option-group--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.option_group.feedback',
    showLabel: true,
    labelClass: 'activities-activity__option-group--input-label',
    labelAttributes: {
      for: 'activities-activity__option-group',
    },
    selectLabel: 'name',
    selectEntity: 'option-group',
    selectMultiple: false,
    withTableSearch: true,
    displayConfigName: 'table',
    withNew: true,
    formConfigName: 'default',
    withInfo: false,
    filters: [
      {
        filterField: 'entity_type',
        modelField: null,
        value: ['bpc_activity'],
      },
    ],
  },
  activity_category_id: {
    fieldPath: 'activity_category_id',
    errorFieldPath: 'activity_category_id',
    fieldReadPath: 'activity_category_id',
    name: 'activity_category_id',
    label: 'activities.activity.activity_category_id.label',
    id: 'activities-activity__activity-category-id',
    veeValidation: true,
    rules: ['nullable', 'exists:activity_categories,id'],
    warningRules: [],
    fieldClass: 'activities-activity__activity-category-id--input',
    showError: true,
    errorClass: 'activities-activity__activity-category-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__activity-category-id--input-help',
    helpAttributes: [],
    help: 'activities.activity.activity_category_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__activity-category-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.activity_category_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__activity-category-id--input-label',
    labelAttributes: {
      for: 'activities-activity__activity-category-id',
    },
  },
  activity_category: {
    fieldPath: 'activity_category',
    errorFieldPath: 'activity_category',
    fieldReadPath: 'activity_category',
    name: 'activity_category',
    label: 'activities.activity.activity_category.label',
    id: 'activities-activity__activity-category',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__activity-category--input',
    showError: true,
    errorClass: 'activities-activity__activity-category--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__activity-category--input-help',
    helpAttributes: [],
    help: 'activities.activity.activity_category.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__activity-category--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.activity_category.feedback',
    showLabel: true,
    labelClass: 'activities-activity__activity-category--input-label',
    labelAttributes: {
      for: 'activities-activity__activity-category',
    },
    selectLabel: 'name',
    selectEntity: 'activity-category',
    selectMultiple: false,
    withTableSearch: false,
    displayConfigName: 'table',
    withNew: true,
    formConfigName: 'default',
  },
  disciplines: {
    fieldPath: 'disciplines',
    errorFieldPath: 'disciplines',
    fieldReadPath: 'disciplines',
    name: 'disciplines',
    label: 'activities.activity.disciplines.label',
    id: 'activities-activity__disciplines',
    veeValidation: true,
    rules: ['nullable', 'array'],
    warningRules: [],
    fieldClass: 'activities-activity__disciplines--input',
    showError: true,
    errorClass: 'activities-activity__disciplines--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__disciplines--input-help',
    helpAttributes: [],
    help: 'activities.activity.disciplines.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__disciplines--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.disciplines.feedback',
    showLabel: true,
    labelClass: 'activities-activity__disciplines--input-label',
    labelAttributes: {
      for: 'activities-activity__disciplines',
    },
    selectLabel: 'name',
    selectValue: 'id',
    selectEntity: 'discipline',
    selectMultiple: true,
  },
  min_age: {
    fieldPath: 'min_age',
    errorFieldPath: 'min_age',
    fieldReadPath: 'min_age',
    name: 'min_age',
    label: 'activities.activity.min_age.label',
    id: 'activities-activity__min-age',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity__min-age--input',
    showError: true,
    errorClass: 'activities-activity__min-age--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__min-age--input-help',
    helpAttributes: [],
    help: 'activities.activity.min_age.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__min-age--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.min_age.feedback',
    showLabel: true,
    labelClass: 'activities-activity__min-age--input-label',
    labelAttributes: {
      for: 'activities-activity__min-age',
    },
  },
  max_age: {
    fieldPath: 'max_age',
    errorFieldPath: 'max_age',
    fieldReadPath: 'max_age',
    name: 'max_age',
    label: 'activities.activity.max_age.label',
    id: 'activities-activity__max-age',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity__max-age--input',
    showError: true,
    errorClass: 'activities-activity__max-age--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__max-age--input-help',
    helpAttributes: [],
    help: 'activities.activity.max_age.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__max-age--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.max_age.feedback',
    showLabel: true,
    labelClass: 'activities-activity__max-age--input-label',
    labelAttributes: {
      for: 'activities-activity__max-age',
    },
  },
  start_date: {
    fieldPath: 'start_date',
    errorFieldPath: 'start_date',
    fieldReadPath: 'start_date',
    name: 'start_date',
    label: 'activities.activity.start_date.label',
    id: 'activities-activity__start-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity__start-date--input',
    showError: true,
    errorClass: 'activities-activity__start-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__start-date--input-help',
    helpAttributes: [],
    help: 'activities.activity.start_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__start-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.start_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity__start-date--input-label',
    labelAttributes: {
      for: 'activities-activity__start-date',
    },
  },
  end_date: {
    fieldPath: 'end_date',
    errorFieldPath: 'end_date',
    fieldReadPath: 'end_date',
    name: 'end_date',
    label: 'activities.activity.end_date.label',
    id: 'activities-activity__end-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity__end-date--input',
    showError: true,
    errorClass: 'activities-activity__end-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__end-date--input-help',
    helpAttributes: [],
    help: 'activities.activity.end_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__end-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.end_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity__end-date--input-label',
    labelAttributes: {
      for: 'activities-activity__end-date',
    },
  },
  color: {
    fieldPath: 'color',
    errorFieldPath: 'color',
    fieldReadPath: 'color',
    name: 'color',
    label: 'global.color.label',
    id: 'activities-activity__color',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'activities-activity__color--input',
    showError: true,
    errorClass: 'activities-activity__color--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__color--input-help',
    helpAttributes: [],
    help: 'activities.activity.color.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__color--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.color.feedback',
    showLabel: true,
    labelClass: 'activities-activity__color--input-label',
    labelAttributes: {
      for: 'activities-activity__color',
    },
  },
  short_description: {
    fieldPath: 'short_description',
    errorFieldPath: 'short_description',
    fieldReadPath: 'short_description',
    name: 'short_description',
    label: 'activities.activity.short_description.label',
    id: 'activities-activity__short-description',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__short-description--input',
    showError: true,
    errorClass: 'activities-activity__short-description--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__short-description--input-help',
    helpAttributes: [],
    help: 'activities.activity.short_description.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__short-description--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.short_description.feedback',
    showLabel: true,
    labelClass: 'activities-activity__short-description--input-label',
    labelAttributes: {
      for: 'activities-activity__short-description',
    },
  },
  description: {
    fieldPath: 'description',
    errorFieldPath: 'description',
    fieldReadPath: 'description',
    name: 'description',
    label: 'activities.activity.description.label',
    id: 'activities-activity__description',
    veeValidation: true,
    rules: ['nullable', 'string'],
    warningRules: [],
    fieldClass: 'activities-activity__description--input',
    showError: true,
    errorClass: 'activities-activity__description--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__description--input-help',
    helpAttributes: [],
    help: 'activities.activity.description.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__description--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.description.feedback',
    showLabel: true,
    labelClass: 'activities-activity__description--input-label',
    labelAttributes: {
      for: 'activities-activity__description',
    },
  },
  published: {
    fieldPath: 'published',
    errorFieldPath: 'published',
    fieldReadPath: 'published',
    name: 'published',
    label: 'activities.activity.published.label',
    options: [
      {
        text: 'global.no',
        value: false,
      },
      {
        text: 'global.yes',
        value: true,
      },
    ],
    id: 'activities-activity__published',
    veeValidation: true,
    rules: ['required', 'boolean'],
    warningRules: [],
    fieldClass: 'activities-activity__published--input',
    showError: true,
    errorClass: 'activities-activity__published--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__published--input-help',
    helpAttributes: [],
    help: 'activities.activity.published.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__published--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.published.feedback',
    showLabel: true,
    labelClass: 'activities-activity__published--input-label',
    labelAttributes: {
      for: 'activities-activity__published',
    },
  },
  publish_start_date: {
    fieldPath: 'publish_start_date',
    errorFieldPath: 'publish_start_date',
    fieldReadPath: 'publish_start_date',
    name: 'publish_start_date',
    label: 'activities.activity.publish_start_date.label',
    id: 'activities-activity__publish-start-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity__publish-start-date--input',
    showError: true,
    errorClass: 'activities-activity__publish-start-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__publish-start-date--input-help',
    helpAttributes: [],
    help: 'activities.activity.publish_start_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__publish-start-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.publish_start_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity__publish-start-date--input-label',
    labelAttributes: {
      for: 'activities-activity__publish-start-date',
    },
  },
  publish_start_time: {
    fieldPath: 'publish_start_time',
    errorFieldPath: 'publish_start_time',
    fieldReadPath: 'publish_start_time',
    name: 'publish_start_time',
    label: 'activities.activity.publish_start_time.label',
    id: 'activities-activity__publish-start-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__publish-start-time--input',
    showError: true,
    errorClass: 'activities-activity__publish-start-time--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__publish-start-time--input-help',
    helpAttributes: [],
    help: 'activities.activity.publish_start_time.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__publish-start-time--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.publish_start_time.feedback',
    showLabel: true,
    labelClass: 'activities-activity__publish-start-time--input-label',
    labelAttributes: {
      for: 'activities-activity__publish-start-time',
    },
  },
  publish_end_date: {
    fieldPath: 'publish_end_date',
    errorFieldPath: 'publish_end_date',
    fieldReadPath: 'publish_end_date',
    name: 'publish_end_date',
    label: 'activities.activity.publish_end_date.label',
    id: 'activities-activity__publish-end-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity__publish-end-date--input',
    showError: true,
    errorClass: 'activities-activity__publish-end-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__publish-end-date--input-help',
    helpAttributes: [],
    help: 'activities.activity.publish_end_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__publish-end-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.publish_end_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity__publish-end-date--input-label',
    labelAttributes: {
      for: 'activities-activity__publish-end-date',
    },
  },
  publish_end_time: {
    fieldPath: 'publish_end_time',
    errorFieldPath: 'publish_end_time',
    fieldReadPath: 'publish_end_time',
    name: 'publish_end_time',
    label: 'activities.activity.publish_end_time.label',
    id: 'activities-activity__publish-end-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__publish-end-time--input',
    showError: true,
    errorClass: 'activities-activity__publish-end-time--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__publish-end-time--input-help',
    helpAttributes: [],
    help: 'activities.activity.publish_end_time.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__publish-end-time--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.publish_end_time.feedback',
    showLabel: true,
    labelClass: 'activities-activity__publish-end-time--input-label',
    labelAttributes: {
      for: 'activities-activity__publish-end-time',
    },
  },
  activities: {
    fieldPath: 'activities',
    errorFieldPath: 'activities',
    fieldReadPath: 'activities',
    name: 'activities',
    label: 'activities.activity.activities.label',
    id: 'activities-activity__activities',
    veeValidation: true,
    rules: ['nullable', 'max:1024'],
    warningRules: [],
    fieldClass: 'activities-activity__activities--input',
    showError: true,
    errorClass: 'activities-activity__activities--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__activities--input-help',
    helpAttributes: [],
    help: 'activities.activity.activities.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__activities--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.activities.feedback',
    showLabel: true,
    labelClass: 'activities-activity__activities--input-label',
    labelAttributes: {
      for: 'activities-activity__activities',
    },
    mediaCollection: {
      name: 'activities',
      singleFile: true,
      acceptsMimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      fallbackUrl: null,
      fallbackPath: null,
      limitedFiles: false,
      limitNumberFiles: 0,
      responsiveImages: false,
    },
  },
  alias: {
    fieldPath: 'alias',
    errorFieldPath: 'alias',
    fieldReadPath: 'alias',
    name: 'alias',
    label: 'activities.activity.alias.label',
    id: 'activities-activity__alias',
    veeValidation: true,
    rules: ['nullable', 'string', 'unique_but_self:activities,alias,bpc_activity'],
    warningRules: [],
    fieldClass: 'activities-activity__alias--input',
    showError: true,
    errorClass: 'activities-activity__alias--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__alias--input-help',
    helpAttributes: [],
    help: 'activities.activity.alias.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__alias--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.alias.feedback',
    showLabel: true,
    labelClass: 'activities-activity__alias--input-label',
    labelAttributes: {
      for: 'activities-activity__alias',
    },
  },
  has_questions: {
    fieldPath: 'has_questions',
    errorFieldPath: 'has_questions',
    fieldReadPath: 'has_questions',
    name: 'has_questions',
    label: 'activities.activity.has_questions.label',
    id: 'activities-activity__has-questions',
    veeValidation: true,
    rules: ['required', 'boolean'],
    warningRules: [],
    fieldClass: 'activities-activity__has-questions--input',
    showError: true,
    errorClass: 'activities-activity__has-questions--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__has-questions--input-help',
    helpAttributes: [],
    help: 'activities.activity.has_questions.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__has-questions--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.has_questions.feedback',
    showLabel: true,
    labelClass: 'activities-activity__has-questions--input-label',
    labelAttributes: {
      for: 'activities-activity__has-questions',
    },
  },
  question_1: {
    fieldPath: 'question_1',
    errorFieldPath: 'question_1',
    fieldReadPath: 'question_1',
    name: 'question_1',
    label: 'activities.activity.question1.label',
    id: 'activities-activity__question1',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question1--input',
    showError: true,
    errorClass: 'activities-activity__question1--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question1--input-help',
    helpAttributes: [],
    help: 'activities.activity.question1.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question1--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question1.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question1--input-label',
    labelAttributes: {
      for: 'activities-activity__question1',
    },
  },
  question_1_type: {
    fieldPath: 'question_1_type',
    errorFieldPath: 'question_1_type',
    fieldReadPath: 'question_1_type',
    name: 'question_1_type',
    label: 'activities.activity.question_type.label',
    options: [
      {
        text: 'global.fields.short_text.label',
        value: 'short_text',
      },
      {
        text: 'global.fields.long_text.label',
        value: 'long_text',
      },
      {
        text: 'global.fields.simple_choice.label',
        value: 'simple_choice',
      },
      {
        text: 'global.fields.multiple_choice.label',
        value: 'multiple_choice',
      },
    ],
    id: 'activities-activity__question1-type',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question1-type--input',
    showError: true,
    errorClass: 'activities-activity__question1-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question1-type--input-help',
    helpAttributes: [],
    help: 'activities.activity.question1_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question1-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question1_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question1-type--input-label',
    labelAttributes: {
      for: 'activities-activity__question1-type',
    },
  },
  question_1_mandatory: {
    fieldPath: 'question_1_mandatory',
    errorFieldPath: 'question_1_mandatory',
    fieldReadPath: 'question_1_mandatory',
    name: 'question_1_mandatory',
    label: 'activities.activity.question_mandatory.label',
    id: 'activities-activity__question1-mandatory',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question1-mandatory--input',
    showError: true,
    errorClass: 'activities-activity__question1-mandatory--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question1-mandatory--input-help',
    helpAttributes: [],
    help: 'activities.activity.question1_mandatory.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question1-mandatory--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question1_mandatory.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question1-mandatory--input-label',
    labelAttributes: {
      for: 'activities-activity__question1-mandatory',
    },
  },
  question_1_options: {
    fieldPath: 'question_1_options',
    errorFieldPath: 'question_1_options',
    fieldReadPath: 'question_1_options',
    name: 'question_1_options',
    label: 'activities.activity.question_options.label',
    id: 'activities-activity__question1-options',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question1-options--input',
    showError: true,
    errorClass: 'activities-activity__question1-options--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question1-options--input-help',
    helpAttributes: [],
    help: 'activities.activity.question1_options.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question1-options--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question1_options.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question1-options--input-label',
    labelAttributes: {
      for: 'activities-activity__question1-options',
    },
  },
  question_2: {
    fieldPath: 'question_2',
    errorFieldPath: 'question_2',
    fieldReadPath: 'question_2',
    name: 'question_2',
    label: 'activities.activity.question2.label',
    id: 'activities-activity__question2',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question2--input',
    showError: true,
    errorClass: 'activities-activity__question2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question2--input-help',
    helpAttributes: [],
    help: 'activities.activity.question2.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question2--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question2.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question2--input-label',
    labelAttributes: {
      for: 'activities-activity__question2',
    },
  },
  question_2_type: {
    fieldPath: 'question_2_type',
    errorFieldPath: 'question_2_type',
    fieldReadPath: 'question_2_type',
    name: 'question_2_type',
    label: 'activities.activity.question_type.label',
    options: [
      {
        text: 'global.fields.short_text.label',
        value: 'short_text',
      },
      {
        text: 'global.fields.long_text.label',
        value: 'long_text',
      },
      {
        text: 'global.fields.simple_choice.label',
        value: 'simple_choice',
      },
      {
        text: 'global.fields.multiple_choice.label',
        value: 'multiple_choice',
      },
    ],
    id: 'activities-activity__question2-type',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question2-type--input',
    showError: true,
    errorClass: 'activities-activity__question2-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question2-type--input-help',
    helpAttributes: [],
    help: 'activities.activity.question2_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question2-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question2_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question2-type--input-label',
    labelAttributes: {
      for: 'activities-activity__question2-type',
    },
  },
  question_2_mandatory: {
    fieldPath: 'question_2_mandatory',
    errorFieldPath: 'question_2_mandatory',
    fieldReadPath: 'question_2_mandatory',
    name: 'question_2_mandatory',
    label: 'activities.activity.question_mandatory.label',
    id: 'activities-activity__question2-mandatory',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question2-mandatory--input',
    showError: true,
    errorClass: 'activities-activity__question2-mandatory--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question2-mandatory--input-help',
    helpAttributes: [],
    help: 'activities.activity.question2_mandatory.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question2-mandatory--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question2_mandatory.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question2-mandatory--input-label',
    labelAttributes: {
      for: 'activities-activity__question2-mandatory',
    },
  },
  question_2_options: {
    fieldPath: 'question_2_options',
    errorFieldPath: 'question_2_options',
    fieldReadPath: 'question_2_options',
    name: 'question_2_options',
    label: 'activities.activity.question_options.label',
    id: 'activities-activity__question2-options',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question2-options--input',
    showError: true,
    errorClass: 'activities-activity__question2-options--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question2-options--input-help',
    helpAttributes: [],
    help: 'activities.activity.question2_options.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question2-options--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question2_options.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question2-options--input-label',
    labelAttributes: {
      for: 'activities-activity__question2-options',
    },
  },
  question_3: {
    fieldPath: 'question_3',
    errorFieldPath: 'question_3',
    fieldReadPath: 'question_3',
    name: 'question_3',
    label: 'activities.activity.question3.label',
    id: 'activities-activity__question3',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question3--input',
    showError: true,
    errorClass: 'activities-activity__question3--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question3--input-help',
    helpAttributes: [],
    help: 'activities.activity.question3.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question3--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question3.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question3--input-label',
    labelAttributes: {
      for: 'activities-activity__question3',
    },
  },
  question_3_type: {
    fieldPath: 'question_3_type',
    errorFieldPath: 'question_3_type',
    fieldReadPath: 'question_3_type',
    name: 'question_3_type',
    label: 'activities.activity.question_type.label',
    options: [
      {
        text: 'global.fields.short_text.label',
        value: 'short_text',
      },
      {
        text: 'global.fields.long_text.label',
        value: 'long_text',
      },
      {
        text: 'global.fields.simple_choice.label',
        value: 'simple_choice',
      },
      {
        text: 'global.fields.multiple_choice.label',
        value: 'multiple_choice',
      },
    ],
    id: 'activities-activity__question3-type',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question3-type--input',
    showError: true,
    errorClass: 'activities-activity__question3-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question3-type--input-help',
    helpAttributes: [],
    help: 'activities.activity.question3_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question3-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question3_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question3-type--input-label',
    labelAttributes: {
      for: 'activities-activity__question3-type',
    },
  },
  question_3_mandatory: {
    fieldPath: 'question_3_mandatory',
    errorFieldPath: 'question_3_mandatory',
    fieldReadPath: 'question_3_mandatory',
    name: 'question_3_mandatory',
    label: 'activities.activity.question_mandatory.label',
    id: 'activities-activity__question3-mandatory',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question3-mandatory--input',
    showError: true,
    errorClass: 'activities-activity__question3-mandatory--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question3-mandatory--input-help',
    helpAttributes: [],
    help: 'activities.activity.question3_mandatory.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question3-mandatory--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question3_mandatory.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question3-mandatory--input-label',
    labelAttributes: {
      for: 'activities-activity__question3-mandatory',
    },
  },
  question_3_options: {
    fieldPath: 'question_3_options',
    errorFieldPath: 'question_3_options',
    fieldReadPath: 'question_3_options',
    name: 'question_3_options',
    label: 'activities.activity.question_options.label',
    id: 'activities-activity__question3-options',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question3-options--input',
    showError: true,
    errorClass: 'activities-activity__question3-options--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question3-options--input-help',
    helpAttributes: [],
    help: 'activities.activity.question3_options.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question3-options--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question3_options.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question3-options--input-label',
    labelAttributes: {
      for: 'activities-activity__question3-options',
    },
  },
  question_4: {
    fieldPath: 'question_4',
    errorFieldPath: 'question_4',
    fieldReadPath: 'question_4',
    name: 'question_4',
    label: 'activities.activity.question4.label',
    id: 'activities-activity__question4',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question4--input',
    showError: true,
    errorClass: 'activities-activity__question4--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question4--input-help',
    helpAttributes: [],
    help: 'activities.activity.question4.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question4--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question4.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question4--input-label',
    labelAttributes: {
      for: 'activities-activity__question4',
    },
  },
  question_4_type: {
    fieldPath: 'question_4_type',
    errorFieldPath: 'question_4_type',
    fieldReadPath: 'question_4_type',
    name: 'question_4_type',
    label: 'activities.activity.question_type.label',
    options: [
      {
        text: 'global.fields.short_text.label',
        value: 'short_text',
      },
      {
        text: 'global.fields.long_text.label',
        value: 'long_text',
      },
      {
        text: 'global.fields.simple_choice.label',
        value: 'simple_choice',
      },
      {
        text: 'global.fields.multiple_choice.label',
        value: 'multiple_choice',
      },
    ],
    id: 'activities-activity__question4-type',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question4-type--input',
    showError: true,
    errorClass: 'activities-activity__question4-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question4-type--input-help',
    helpAttributes: [],
    help: 'activities.activity.question4_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question4-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question4_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question4-type--input-label',
    labelAttributes: {
      for: 'activities-activity__question4-type',
    },
  },
  question_4_mandatory: {
    fieldPath: 'question_4_mandatory',
    errorFieldPath: 'question_4_mandatory',
    fieldReadPath: 'question_4_mandatory',
    name: 'question_4_mandatory',
    label: 'activities.activity.question_mandatory.label',
    id: 'activities-activity__question4-mandatory',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question4-mandatory--input',
    showError: true,
    errorClass: 'activities-activity__question4-mandatory--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question4-mandatory--input-help',
    helpAttributes: [],
    help: 'activities.activity.question4_mandatory.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question4-mandatory--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question4_mandatory.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question4-mandatory--input-label',
    labelAttributes: {
      for: 'activities-activity__question4-mandatory',
    },
  },
  question_4_options: {
    fieldPath: 'question_4_options',
    errorFieldPath: 'question_4_options',
    fieldReadPath: 'question_4_options',
    name: 'question_4_options',
    label: 'activities.activity.question_options.label',
    id: 'activities-activity__question4-options',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question4-options--input',
    showError: true,
    errorClass: 'activities-activity__question4-options--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question4-options--input-help',
    helpAttributes: [],
    help: 'activities.activity.question4_options.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question4-options--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question4_options.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question4-options--input-label',
    labelAttributes: {
      for: 'activities-activity__question4-options',
    },
  },
  question_5: {
    fieldPath: 'question_5',
    errorFieldPath: 'question_5',
    fieldReadPath: 'question_5',
    name: 'question_5',
    label: 'activities.activity.question5.label',
    id: 'activities-activity__question5',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question5--input',
    showError: true,
    errorClass: 'activities-activity__question5--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question5--input-help',
    helpAttributes: [],
    help: 'activities.activity.question5.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question5--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question5.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question5--input-label',
    labelAttributes: {
      for: 'activities-activity__question5',
    },
  },
  question_5_type: {
    fieldPath: 'question_5_type',
    errorFieldPath: 'question_5_type',
    fieldReadPath: 'question_5_type',
    name: 'question_5_type',
    label: 'activities.activity.question_type.label',
    options: [
      {
        text: 'global.fields.short_text.label',
        value: 'short_text',
      },
      {
        text: 'global.fields.long_text.label',
        value: 'long_text',
      },
      {
        text: 'global.fields.simple_choice.label',
        value: 'simple_choice',
      },
      {
        text: 'global.fields.multiple_choice.label',
        value: 'multiple_choice',
      },
    ],
    id: 'activities-activity__question5-type',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question5-type--input',
    showError: true,
    errorClass: 'activities-activity__question5-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question5-type--input-help',
    helpAttributes: [],
    help: 'activities.activity.question5_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question5-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question5_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question5-type--input-label',
    labelAttributes: {
      for: 'activities-activity__question5-type',
    },
  },
  question_5_mandatory: {
    fieldPath: 'question_5_mandatory',
    errorFieldPath: 'question_5_mandatory',
    fieldReadPath: 'question_5_mandatory',
    name: 'question_5_mandatory',
    label: 'activities.activity.question_mandatory.label',
    id: 'activities-activity__question5-mandatory',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question5-mandatory--input',
    showError: true,
    errorClass: 'activities-activity__question5-mandatory--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question5-mandatory--input-help',
    helpAttributes: [],
    help: 'activities.activity.question5_mandatory.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question5-mandatory--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question5_mandatory.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question5-mandatory--input-label',
    labelAttributes: {
      for: 'activities-activity__question5-mandatory',
    },
  },
  question_5_options: {
    fieldPath: 'question_5_options',
    errorFieldPath: 'question_5_options',
    fieldReadPath: 'question_5_options',
    name: 'question_5_options',
    label: 'activities.activity.question_options.label',
    id: 'activities-activity__question5-options',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity__question5-options--input',
    showError: true,
    errorClass: 'activities-activity__question5-options--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity__question5-options--input-help',
    helpAttributes: [],
    help: 'activities.activity.question5_options.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__question5-options--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.question5_options.feedback',
    showLabel: true,
    labelClass: 'activities-activity__question5-options--input-label',
    labelAttributes: {
      for: 'activities-activity__question5-options',
    },
  },
  period_id: {
    fieldPath: 'period_id',
    errorFieldPath: 'period_id',
    fieldReadPath: 'period_id',
    name: 'period_id',
    label: 'activities.activity.period.label',
    id: 'selects-activity__period-id',
    veeValidation: true,
    fieldClass: 'activities-activity__period_id--input',
    showError: true,
    errorAttributes: [],
    showLabel: true,
    labelClass: 'activities-activity__period_id--input-label',
    labelAttributes: {
      for: 'activities-activity__period_id',
    },
  },
  period: {
    fieldPath: 'period',
    fieldReadPath: 'period',
    name: 'period',
    label: 'activities.activity.period.label',
    id: 'selects-activity__period-id',
    rules: [],
    selectLabel: 'name',
    selectEntity: 'period',
    selectMultiple: false,
    veeValidation: true,
    fieldClass: 'activities-activity__period_id--input',
    showError: true,
    errorAttributes: [],
    showLabel: true,
    labelClass: 'activities-activity__period_id--input-label',
    labelAttributes: {
      for: 'activities-activity__period_id',
    },
  },
  time_slots: {
    fieldPath: 'time_slots',
    errorFieldPath: 'time_slots',
    fieldReadPath: 'time_slots',
    name: 'time_slots',
    label: 'activities.activity_group.time_slots.label',
    id: 'activities-activity-group__time-slots',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__time-slots--input',
    showError: true,
    errorClass: 'activities-activity-group__time-slots--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__time-slots--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.time_slots.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__time-slots--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.time_slots.feedback',
    showLabel: false,
    labelClass: 'activities-activity-group__time-slots--input-label',
    labelAttributes: {
      for: 'activities-activity-group__time-slots',
    },
  },
};
export const activityGroupFields = {
  id: {
    fieldPath: 'id',
    errorFieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
    label: 'activities.activity_group.id.label',
    id: 'activities-activity-group__id',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'activities-activity-group__id--input',
    showError: true,
    errorClass: 'activities-activity-group__id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__id--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.id.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__id--input-label',
    labelAttributes: {
      for: 'activities-activity-group__id',
    },
  },
  center_id: {
    fieldPath: 'center_id',
    errorFieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
    label: 'activities.activity_group.center_id.label',
    id: 'activities-activity-group__center-id',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'activities-activity-group__center-id--input',
    showError: true,
    errorClass: 'activities-activity-group__center-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__center-id--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.center_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__center-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.center_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__center-id--input-label',
    labelAttributes: {
      for: 'activities-activity-group__center-id',
    },
  },
  code: {
    fieldPath: 'code',
    errorFieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'activities.activity_group.code.label',
    id: 'activities-activity-group__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    fieldClass: 'activities-activity-group__code--input',
    showError: true,
    errorClass: 'activities-activity-group__code--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__code--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.code.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__code--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.code.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__code--input-label',
    labelAttributes: {
      for: 'activities-activity-group__code',
    },
    codePrefix: 'GRP',
  },
  status: {
    fieldPath: 'status',
    errorFieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'activities.activity_group.status.label',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
    ],
    id: 'activities-activity-group__status',
    veeValidation: true,
    rules: ['required', 'in:active,inactive'],
    warningRules: [],
    fieldClass: 'activities-activity-group__status--input',
    showError: true,
    errorClass: 'activities-activity-group__status--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__status--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.status.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__status--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.status.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__status--input-label',
    labelAttributes: {
      for: 'activities-activity-group__status',
    },
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'inactive',
        color: 'border-0 text-white bg-danger',
      },
    ],
  },
  activity_type: {
    fieldPath: 'activity_type',
    errorFieldPath: 'activity_type',
    fieldReadPath: 'activity_type',
    name: 'activity_type',
    label: 'activities.activity_group.activity_type.label',
    id: 'activities-activity-group__activity-type',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'activities-activity-group__activity-type--input',
    showError: true,
    errorClass: 'activities-activity-group__activity-type--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__activity-type--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.activity_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__activity-type--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.activity_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__activity-type--input-label',
    labelAttributes: {
      for: 'activities-activity-group__activity-type',
    },
  },
  activity_id: {
    fieldPath: 'activity_id',
    errorFieldPath: 'activity_id',
    fieldReadPath: 'activity_id',
    name: 'activity_id',
    label: 'activities.activity_group.activity_id.label',
    id: 'activities-activity-group__activity-id',
    veeValidation: true,
    rules: ['required', 'exists:activities,id'],
    warningRules: [],
    fieldClass: 'activities-activity-group__activity-id--input',
    showError: true,
    errorClass: 'activities-activity-group__activity-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__activity-id--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.activity_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__activity-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.activity_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__activity-id--input-label',
    labelAttributes: {
      for: 'activities-activity-group__activity-id',
    },
  },
  activity: {
    fieldPath: 'activity',
    errorFieldPath: 'activity',
    fieldReadPath: 'activity',
    name: 'activity',
    label: 'activities.activity_group.activity.label',
    id: 'activities-activity-group__activity',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__activity--input',
    showError: true,
    errorClass: 'activities-activity-group__activity--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__activity--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.activity.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__activity--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.activity.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__activity--input-label',
    labelAttributes: {
      for: 'activities-activity-group__activity',
    },
    selectLabel: 'name',
    selectEntity: 'bpc-activity',
    selectMultiple: false,
    withTableSearch: true,
    displayConfigName: 'search',
    withNew: true,
    formConfigName: 'default',
  },
  name: {
    fieldPath: 'name',
    errorFieldPath: 'name',
    fieldReadPath: 'name',
    name: 'name',
    label: 'activities.activity_group.name.label',
    id: 'activities-activity-group__name',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'activities-activity-group__name--input',
    showError: true,
    errorClass: 'activities-activity-group__name--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__name--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.name.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__name--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.name.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__name--input-label',
    labelAttributes: {
      for: 'activities-activity-group__name',
    },
  },
  contacts: {
    fieldPath: 'contacts',
    errorFieldPath: 'contacts',
    fieldReadPath: 'contacts',
    name: 'contacts',
    label: 'activities.activity_group.contacts.label',
    id: 'activities-activity-group__contacts',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'activities-activity-group__contacts--input',
    showError: true,
    errorClass: 'activities-activity-group__contacts--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__contacts--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.contacts.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__contacts--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.contacts.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__contacts--input-label',
    labelAttributes: {
      for: 'activities-activity-group__contacts',
    },
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectMultiple: true,
    filters: [
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
    ],
  },
  resource_id: {
    fieldPath: 'resource_id',
    errorFieldPath: 'resource_id',
    fieldReadPath: 'resource_id',
    name: 'resource_id',
    label: 'activities.activity_group.resource_id.label',
    id: 'activities-activity-group__resource-id',
    veeValidation: true,
    rules: ['nullable', 'exists:resources,id'],
    warningRules: [],
    fieldClass: 'activities-activity-group__resource-id--input',
    showError: true,
    errorClass: 'activities-activity-group__resource-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__resource-id--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.resource_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__resource-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.resource_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__resource-id--input-label',
    labelAttributes: {
      for: 'activities-activity-group__resource-id',
    },
  },
  resource: {
    fieldPath: 'resource',
    errorFieldPath: 'resource',
    fieldReadPath: 'resource',
    name: 'resource',
    label: 'activities.activity_group.resource.label',
    id: 'activities-activity-group__resource',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__resource--input',
    showError: true,
    errorClass: 'activities-activity-group__resource--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__resource--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.resource.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__resource--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.resource.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__resource--input-label',
    labelAttributes: {
      for: 'activities-activity-group__resource',
    },
    selectLabel: 'name',
    selectValue: 'id',
    selectEntity: 'resource',
    selectMultiple: false,
    selectClearable: true,
  },
  article_id: {
    fieldPath: 'article_id',
    errorFieldPath: 'article_id',
    fieldReadPath: 'article_id',
    name: 'article_id',
    label: 'activities.activity_group.article_id.label',
    id: 'activities-activity-group__article-id',
    veeValidation: true,
    rules: ['nullable', 'exists:articles,id'],
    warningRules: [],
    fieldClass: 'activities-activity-group__article-id--input',
    showError: true,
    errorClass: 'activities-activity-group__article-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__article-id--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.article_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__article-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.article_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__article-id--input-label',
    labelAttributes: {
      for: 'activities-activity-group__article-id',
    },
  },
  article: {
    fieldPath: 'article',
    errorFieldPath: 'article',
    fieldReadPath: 'article',
    name: 'article',
    label: 'activities.activity_group.article.label',
    id: 'activities-activity-group__article',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__article--input',
    showError: true,
    errorClass: 'activities-activity-group__article--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__article--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.article.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__article--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.article.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__article--input-label',
    labelAttributes: {
      for: 'activities-activity-group__article',
    },
    selectLabel: 'name',
    selectValue: 'id',
    selectEntity: 'article',
    selectMultiple: false,
    withTableSearch: false,
    displayConfigName: 'search',
    withNew: false,
    formConfigName: 'default',
    filters: [
      {
        filterField: 'article_type',
        modelField: null,
        value: 'enrollment',
      },
    ],
  },
  discounts: {
    fieldPath: 'discounts',
    errorFieldPath: 'discounts',
    fieldReadPath: 'discounts',
    name: 'discounts',
    label: 'activities.activity_group.discounts.label',
    id: 'activities-activity-group__discounts',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'activities-activity-group__discounts--input',
    showError: true,
    errorClass: 'activities-activity-group__discounts--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__discounts--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.discounts.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__discounts--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.discounts.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__discounts--input-label',
    labelAttributes: {
      for: 'activities-activity-group__discounts',
    },
    selectLabel: 'name',
    selectEntity: 'discount',
    selectMultiple: true,
    filters: [
      {
        filterField: 'apply_to',
        modelField: null,
        value: 'enrollment',
      },
    ],
  },
  min_age: {
    fieldPath: 'min_age',
    errorFieldPath: 'min_age',
    fieldReadPath: 'min_age',
    name: 'min_age',
    label: 'activities.activity_group.min_age.label',
    id: 'activities-activity-group__min-age',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity-group__min-age--input',
    showError: true,
    errorClass: 'activities-activity-group__min-age--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__min-age--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.min_age.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__min-age--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.min_age.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__min-age--input-label',
    labelAttributes: {
      for: 'activities-activity-group__min-age',
    },
  },
  max_age: {
    fieldPath: 'max_age',
    errorFieldPath: 'max_age',
    fieldReadPath: 'max_age',
    name: 'max_age',
    label: 'activities.activity_group.max_age.label',
    id: 'activities-activity-group__max-age',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity-group__max-age--input',
    showError: true,
    errorClass: 'activities-activity-group__max-age--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__max-age--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.max_age.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__max-age--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.max_age.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__max-age--input-label',
    labelAttributes: {
      for: 'activities-activity-group__max-age',
    },
  },
  min_enrollments: {
    fieldPath: 'min_enrollments',
    errorFieldPath: 'min_enrollments',
    fieldReadPath: 'min_enrollments',
    name: 'min_enrollments',
    label: 'activities.activity_group.min_enrollments.label',
    id: 'activities-activity-group__min-enrollments',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity-group__min-enrollments--input',
    showError: true,
    errorClass: 'activities-activity-group__min-enrollments--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__min-enrollments--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.min_enrollments.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__min-enrollments--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.min_enrollments.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__min-enrollments--input-label',
    labelAttributes: {
      for: 'activities-activity-group__min-enrollments',
    },
  },
  max_enrollments: {
    fieldPath: 'max_enrollments',
    errorFieldPath: 'max_enrollments',
    fieldReadPath: 'max_enrollments',
    name: 'max_enrollments',
    label: 'activities.activity_group.max_enrollments.label',
    id: 'activities-activity-group__max-enrollments',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity-group__max-enrollments--input',
    showError: true,
    errorClass: 'activities-activity-group__max-enrollments--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__max-enrollments--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.max_enrollments.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__max-enrollments--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.max_enrollments.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__max-enrollments--input-label',
    labelAttributes: {
      for: 'activities-activity-group__max-enrollments',
    },
  },
  priorityActivityGroups: {
    fieldPath: 'priorityActivityGroups',
    errorFieldPath: 'priorityActivityGroups',
    fieldReadPath: 'priority_activity_groups',
    name: 'priorityActivityGroups',
    label: 'activities.activity_group.priority_activity_groups.label',
    id: 'activities-activity-group__priority-activity-groups',
    veeValidation: true,
    rules: ['nullable', 'array'],
    warningRules: [],
    fieldClass: 'activities-activity-group__priority-activity-groups--input',
    showError: true,
    errorClass: 'activities-activity-group__priority-activity-groups--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__priority-activity-groups--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.priority_activity_groups.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__priority-activity-groups--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.priority_activity_groups.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__priority-activity-groups--input-label',
    labelAttributes: {
      for: 'activities-activity-group__priority-activity-groups',
    },
    selectLabel: 'name',
    selectEntity: 'activity-group',
    selectMultiple: true,
    template: 'extended',
  },
  previous_days_to_open_attendees: {
    fieldPath: 'previous_days_to_open_attendees',
    errorFieldPath: 'previous_days_to_open_attendees',
    fieldReadPath: 'previous_days_to_open_attendees',
    name: 'previous_days_to_open_attendees',
    label: 'activities.activity_group.previous_days_to_open_attendees.label',
    id: 'activities-activity-group__previous-days-to-open-attendees',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity-group__previous-days-to-open-attendees--input',
    showError: true,
    errorClass: 'activities-activity-group__previous-days-to-open-attendees--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__previous-days-to-open-attendees--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.previous_days_to_open_attendees.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__previous-days-to-open-attendees--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.previous_days_to_open_attendees.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__previous-days-to-open-attendees--input-label',
    labelAttributes: {
      for: 'activities-activity-group__previous-days-to-open-attendees',
    },
  },
  previous_days_to_close_attendees: {
    fieldPath: 'previous_days_to_close_attendees',
    errorFieldPath: 'previous_days_to_close_attendees',
    fieldReadPath: 'previous_days_to_close_attendees',
    name: 'previous_days_to_close_attendees',
    label: 'activities.activity_group.previous_days_to_close_attendees.label',
    id: 'activities-activity-group__previous-days-to-close-attendees',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    warningRules: [],
    fieldClass: 'activities-activity-group__previous-days-to-close-attendees--input',
    showError: true,
    errorClass: 'activities-activity-group__previous-days-to-close-attendees--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__previous-days-to-close-attendees--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.previous_days_to_close_attendees.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__previous-days-to-close-attendees--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.previous_days_to_close_attendees.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__previous-days-to-close-attendees--input-label',
    labelAttributes: {
      for: 'activities-activity-group__previous-days-to-close-attendees',
    },
  },
  short_description: {
    fieldPath: 'short_description',
    errorFieldPath: 'short_description',
    fieldReadPath: 'short_description',
    name: 'short_description',
    label: 'activities.activity_group.short_description.label',
    id: 'activities-activity-group__short-description',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__short-description--input',
    showError: true,
    errorClass: 'activities-activity-group__short-description--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__short-description--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.short_description.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__short-description--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.short_description.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__short-description--input-label',
    labelAttributes: {
      for: 'activities-activity-group__short-description',
    },
  },
  description: {
    fieldPath: 'description',
    errorFieldPath: 'description',
    fieldReadPath: 'description',
    name: 'description',
    label: 'activities.activity_group.description.label',
    id: 'activities-activity-group__description',
    veeValidation: true,
    rules: ['nullable', 'string'],
    warningRules: [],
    fieldClass: 'activities-activity-group__description--input',
    showError: true,
    errorClass: 'activities-activity-group__description--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__description--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.description.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__description--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.description.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__description--input-label',
    labelAttributes: {
      for: 'activities-activity-group__description',
    },
  },
  published: {
    fieldPath: 'published',
    errorFieldPath: 'published',
    fieldReadPath: 'published',
    name: 'published',
    label: 'activities.activity_group.published.label',
    options: [
      {
        text: 'global.no',
        value: false,
      },
      {
        text: 'global.yes',
        value: true,
      },
    ],
    id: 'activities-activity-group__published',
    veeValidation: true,
    rules: ['required', 'boolean'],
    warningRules: [],
    fieldClass: 'activities-activity-group__published--input',
    showError: true,
    errorClass: 'activities-activity-group__published--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__published--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.published.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__published--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.published.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__published--input-label',
    labelAttributes: {
      for: 'activities-activity-group__published',
    },
    defaultValue: false,
  },
  publish_start_date: {
    fieldPath: 'publish_start_date',
    errorFieldPath: 'publish_start_date',
    fieldReadPath: 'publish_start_date',
    name: 'publish_start_date',
    label: 'activities.activity_group.publish_start_date.label',
    id: 'activities-activity-group__publish-start-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity-group__publish-start-date--input',
    showError: true,
    errorClass: 'activities-activity-group__publish-start-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__publish-start-date--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.publish_start_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__publish-start-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.publish_start_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__publish-start-date--input-label',
    labelAttributes: {
      for: 'activities-activity-group__publish-start-date',
    },
  },
  publish_start_time: {
    fieldPath: 'publish_start_time',
    errorFieldPath: 'publish_start_time',
    fieldReadPath: 'publish_start_time',
    name: 'publish_start_time',
    label: 'activities.activity_group.publish_start_time.label',
    id: 'activities-activity-group__publish-start-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__publish-start-time--input',
    showError: true,
    errorClass: 'activities-activity-group__publish-start-time--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__publish-start-time--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.publish_start_time.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__publish-start-time--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.publish_start_time.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__publish-start-time--input-label',
    labelAttributes: {
      for: 'activities-activity-group__publish-start-time',
    },
  },
  publish_end_date: {
    fieldPath: 'publish_end_date',
    errorFieldPath: 'publish_end_date',
    fieldReadPath: 'publish_end_date',
    name: 'publish_end_date',
    label: 'activities.activity_group.publish_end_date.label',
    id: 'activities-activity-group__publish-end-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity-group__publish-end-date--input',
    showError: true,
    errorClass: 'activities-activity-group__publish-end-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__publish-end-date--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.publish_end_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__publish-end-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.publish_end_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__publish-end-date--input-label',
    labelAttributes: {
      for: 'activities-activity-group__publish-end-date',
    },
  },
  publish_end_time: {
    fieldPath: 'publish_end_time',
    errorFieldPath: 'publish_end_time',
    fieldReadPath: 'publish_end_time',
    name: 'publish_end_time',
    label: 'activities.activity_group.publish_end_time.label',
    id: 'activities-activity-group__publish-end-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__publish-end-time--input',
    showError: true,
    errorClass: 'activities-activity-group__publish-end-time--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__publish-end-time--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.publish_end_time.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__publish-end-time--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.publish_end_time.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__publish-end-time--input-label',
    labelAttributes: {
      for: 'activities-activity-group__publish-end-time',
    },
  },
  enrollment_allowed: {
    fieldPath: 'enrollment_allowed',
    errorFieldPath: 'enrollment_allowed',
    fieldReadPath: 'enrollment_allowed',
    name: 'enrollment_allowed',
    label: 'activities.activity_group.enrollment_allowed.label',
    options: [
      {
        text: 'global.no',
        value: false,
      },
      {
        text: 'global.yes',
        value: true,
      },
    ],
    id: 'activities-activity-group__enrollment-allowed',
    veeValidation: true,
    rules: ['required', 'boolean'],
    warningRules: [],
    fieldClass: 'activities-activity-group__enrollment-allowed--input',
    showError: true,
    errorClass: 'activities-activity-group__enrollment-allowed--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__enrollment-allowed--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.enrollment_allowed.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__enrollment-allowed--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.enrollment_allowed.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__enrollment-allowed--input-label',
    labelAttributes: {
      for: 'activities-activity-group__enrollment-allowed',
    },
  },
  enrollment_start_date: {
    fieldPath: 'enrollment_start_date',
    errorFieldPath: 'enrollment_start_date',
    fieldReadPath: 'enrollment_start_date',
    name: 'enrollment_start_date',
    label: 'activities.activity_group.enrollment_start_date.label',
    id: 'activities-activity-group__enrollment-start-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity-group__enrollment-start-date--input',
    showError: true,
    errorClass: 'activities-activity-group__enrollment-start-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__enrollment-start-date--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.enrollment_start_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__enrollment-start-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.enrollment_start_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__enrollment-start-date--input-label',
    labelAttributes: {
      for: 'activities-activity-group__enrollment-start-date',
    },
  },
  enrollment_start_time: {
    fieldPath: 'enrollment_start_time',
    errorFieldPath: 'enrollment_start_time',
    fieldReadPath: 'enrollment_start_time',
    name: 'enrollment_start_time',
    label: 'activities.activity_group.enrollment_start_time.label',
    id: 'activities-activity-group__enrollment-start-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__enrollment-start-time--input',
    showError: true,
    errorClass: 'activities-activity-group__enrollment-start-time--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__enrollment-start-time--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.enrollment_start_time.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__enrollment-start-time--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.enrollment_start_time.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__enrollment-start-time--input-label',
    labelAttributes: {
      for: 'activities-activity-group__enrollment-start-time',
    },
  },
  enrollment_end_date: {
    fieldPath: 'enrollment_end_date',
    errorFieldPath: 'enrollment_end_date',
    fieldReadPath: 'enrollment_end_date',
    name: 'enrollment_end_date',
    label: 'activities.activity_group.enrollment_end_date.label',
    id: 'activities-activity-group__enrollment-end-date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    fieldClass: 'activities-activity-group__enrollment-end-date--input',
    showError: true,
    errorClass: 'activities-activity-group__enrollment-end-date--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__enrollment-end-date--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.enrollment_end_date.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__enrollment-end-date--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.enrollment_end_date.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__enrollment-end-date--input-label',
    labelAttributes: {
      for: 'activities-activity-group__enrollment-end-date',
    },
  },
  enrollment_end_time: {
    fieldPath: 'enrollment_end_time',
    errorFieldPath: 'enrollment_end_time',
    fieldReadPath: 'enrollment_end_time',
    name: 'enrollment_end_time',
    label: 'activities.activity_group.enrollment_end_time.label',
    id: 'activities-activity-group__enrollment-end-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__enrollment-end-time--input',
    showError: true,
    errorClass: 'activities-activity-group__enrollment-end-time--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__enrollment-end-time--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.enrollment_end_time.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__enrollment-end-time--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.enrollment_end_time.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__enrollment-end-time--input-label',
    labelAttributes: {
      for: 'activities-activity-group__enrollment-end-time',
    },
  },
  with_waiting_list: {
    fieldPath: 'with_waiting_list',
    errorFieldPath: 'with_waiting_list',
    fieldReadPath: 'with_waiting_list',
    name: 'with_waiting_list',
    label: 'activities.activity_group.with_waiting_list.label',
    options: [
      {
        text: 'global.no',
        value: '0',
      },
      {
        text: 'global.yes',
        value: '1',
      },
    ],
    id: 'activities-activity-group__with-waiting-list',
    veeValidation: true,
    rules: ['required', 'boolean'],
    warningRules: [],
    fieldClass: 'activities-activity-group__with-waiting-list--input',
    showError: true,
    errorClass: 'activities-activity-group__with-waiting-list--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__with-waiting-list--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.with_waiting_list.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__with-waiting-list--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.with_waiting_list.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__with-waiting-list--input-label',
    labelAttributes: {
      for: 'activities-activity-group__with-waiting-list',
    },
  },
  booking: {
    fieldPath: 'booking',
    errorFieldPath: 'booking',
    fieldReadPath: 'bookings',
    name: 'booking',
    label: 'activities.activity_group.booking.label',
    id: 'activities-activity-group__booking',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__booking--input',
    showError: true,
    errorClass: 'activities-activity-group__booking--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__booking--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.booking.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__booking--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.booking.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__booking--input-label',
    labelAttributes: {
      for: 'activities-activity-group__booking',
    },
    selectEntity: 'booking',
    selectPluralEntity: 'bookings',
    filters: [
      {
        filterField: 'activity_group_id',
        modelField: 'id',
      },
    ],
    fieldForStorage: 'activity_group_id',
    withDraft: false,
    permissionEntityName: 'activity_groups',
    createFormConfigName: 'default-without-activity-group',
    editFormConfigName: 'default-edit-without-activity-group',
    defaultValue: [],
  },
  enrollment: {
    fieldPath: 'enrollment',
    errorFieldPath: 'enrollment',
    fieldReadPath: 'enrollments',
    name: 'enrollment',
    label: 'activities.activity_group.enrollment.label',
    id: 'activities-activity-group__enrollment',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__enrollment--input',
    showError: true,
    errorClass: 'activities-activity-group__enrollment--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__enrollment--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.enrollment.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__enrollment--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.enrollment.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__enrollment--input-label',
    labelAttributes: {
      for: 'activities-activity-group__enrollment',
    },
    selectEntity: 'enrollment',
    selectPluralEntity: 'enrollments',
    filters: [
      {
        filterField: 'activity_group_id',
        modelField: 'id',
      },
    ],
    fieldForStorage: 'activity_group_id',
    withDraft: false,
    permissionEntityName: 'activity_groups',
    formConfigName: 'default-without-activity-fields',
    filterConfigName: 'only-extended-if-have',
    defaultValue: [],
  },
  activityGroupWaitingContacts: {
    fieldPath: 'activityGroupWaitingContacts',
    errorFieldPath: 'activityGroupWaitingContacts',
    fieldReadPath: 'activityGroupWaitingContacts',
    name: 'activityGroupWaitingContacts',
    label: 'activities.activity_group.activity_group_waiting_contacts.label',
    id: 'activities-activity-group__activity-group-waiting-contacts',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__activity-group-waiting-contacts--input',
    showError: true,
    errorClass: 'activities-activity-group__activity-group-waiting-contacts--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__activity-group-waiting-contacts--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.activity_group_waiting_contacts.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__activity-group-waiting-contacts--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.activity_group_waiting_contacts.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__activity-group-waiting-contacts--input-label',
    labelAttributes: {
      for: 'activities-activity-group__activity-group-waiting-contacts',
    },
    selectEntity: 'activity-group-waiting-contact',
    selectPluralEntity: 'activity-group-waiting-contacts',
    filters: [
      {
        filterField: 'activity_group_id',
        modelField: 'id',
      },
    ],
    fieldForStorage: 'activity_group_id',
    withDraft: false,
    permissionEntityName: 'activity_groups',
    formConfigName: 'default-without-activity-group',
    editFormConfigName: 'default',
    defaultValue: [],
  },
  messages: {
    fieldPath: 'messages',
    errorFieldPath: 'messages',
    fieldReadPath: 'messages',
    name: 'messages',
    label: 'activities.activity_group.messages.label',
    id: 'activities-activity-group__messages',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'activities-activity-group__messages--input',
    showError: true,
    errorClass: 'activities-activity-group__messages--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__messages--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.messages.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__messages--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.messages.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__messages--input-label',
    labelAttributes: {
      for: 'activities-activity-group__messages',
    },
    filters: [
      {
        filterField: 'related_entity_name',
        value: 'activity_group',
      },
      {
        filterField: 'from_enrollments_related_with_activity_group_id',
        modelField: 'id',
      },
    ],
  },
  time_slots: {
    fieldPath: 'time_slots',
    errorFieldPath: 'time_slots',
    fieldReadPath: 'time_slots',
    name: 'time_slots',
    label: 'activities.activity_group.time_slots.label',
    id: 'activities-activity-group__time-slots',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__time-slots--input',
    showError: true,
    errorClass: 'activities-activity-group__time-slots--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__time-slots--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.time_slots.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__time-slots--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.time_slots.feedback',
    showLabel: false,
    labelClass: 'activities-activity-group__time-slots--input-label',
    labelAttributes: {
      for: 'activities-activity-group__time-slots',
    },
  },
  activitySessions: {
    fieldPath: 'activitySessions',
    errorFieldPath: 'activitySessions',
    fieldReadPath: 'activitySessions',
    name: 'activitySessions',
    label: 'activities.sessions_of_the_group.label',
    id: 'activities-activity-group__activity-sessions',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__activity-sessions--input',
    showError: true,
    errorClass: 'activities-activity-group__activity-sessions--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__activity-sessions--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.activity_sessions.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__activity-sessions--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.activity_sessions.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__activity-sessions--input-label',
    labelAttributes: {
      for: 'activities-activity-group__activity-sessions',
    },
    selectEntity: 'activity-session',
    selectPluralEntity: 'activity-sessions',
    filters: [
      {
        filterField: 'activity_id',
        modelField: 'activity_id',
      },
      {
        filterField: 'activity_group_id',
        modelField: 'id',
      },
    ],
    fieldForStorage: 'activity_group_id',
    withDraft: false,
    permissionEntityName: 'activity',
    formConfigName: 'create-from-group',
    editFormConfigName: 'edit',
    defaultValue: [],
    selectConfigName: [''],
  },
};

export const activityExtendedFilterFields = {
  status: {
    label: 'activities.activity.status.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'selects.resource.status.active',
        value: 'active',
      },
      {
        text: 'selects.resource.status.inactive',
        value: 'inactive',
      },
      {
        text: 'selects.resource.status.trash',
        value: 'trash',
      },
    ],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__status--input',
    showError: true,
    errorClass: 'activities-activity__status--input-error',
    showHelp: false,
    helpClass: 'activities-activity__status--input-help',
    help: 'activities.activity.status.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__status--input-feedback',
    feedback: 'activities.activity.status.feedback',
    showLabel: true,
    labelClass: 'activities-activity__status--input-label',
    placeholder: '',
  },
  period: {
    label: 'activities.activity.period.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'activities.activity.period.past',
        value: 'past',
      },
      {
        text: 'activities.activity.period.ongoing',
        value: 'ongoing',
      },
      {
        text: 'activities.activity.period.ongoing_upcoming',
        value: 'ongoing_upcoming',
      },
      {
        text: 'activities.activity.period.upcoming',
        value: 'upcoming',
      },
    ],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__period--input',
    showError: true,
    errorClass: 'activities-activity__period--input-error',
    showHelp: false,
    helpClass: 'activities-activity__period--input-help',
    help: 'activities.activity.period.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__period--input-feedback',
    feedback: 'activities.activity.period.feedback',
    showLabel: true,
    labelClass: 'activities-activity__period--input-label',
    placeholder: '',
  },
  activity_type: {
    name: 'activity_type',
    label: 'activities.activity.activity_type.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.activity.camp_label',
        value: 'camp',
        description: 'global.activity.camp.description',
      },
      {
        text: 'global.activity.course',
        value: 'course',
        description: 'global.activity.course.description',
      },
      {
        text: 'global.activity.session',
        value: 'session',
        description: 'global.activity.session.description',
      },
      {
        text: 'global.activity.training',
        value: 'training',
        description: 'global.activity.training.description',
      },
      {
        text: 'global.activity.competition_label',
        value: 'competition',
        description: 'global.activity.competition.description',
      },
      {
        text: 'global.activity.learning_label',
        value: 'learning',
        description: 'global.activity.learning.description',
      },
      {
        text: 'global.activity.exam',
        value: 'exam',
        description: 'global.activity.exam.description',
      },
    ],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__activity-type--input',
    showError: true,
    errorClass: 'activities-activity__activity-type--input-error',
    showHelp: false,
    helpClass: 'activities-activity__activity-type--input-help',
    help: 'activities.activity.activity_type.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__activity-type--input-feedback',
    feedback: 'activities.activity.activity_type.feedback',
    showLabel: true,
    labelClass: 'activities-activity__activity-type--input-label',
    placeholder: '',
  },
  activity_category_id: {
    name: 'activity_category_id',
    label: 'activities.activity.activity_category.label',
    inputType: 'entity-select',
    options: [],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__activity-category-id--input',
    showError: true,
    errorClass: 'activities-activity__activity-category-id--input-error',
    showHelp: false,
    helpClass: 'activities-activity__activity-category-id--input-help',
    help: 'activities.activity.activity_category_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__activity-category-id--input-feedback',
    feedback: 'activities.activity.activity_category_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__activity-category-id--input-label',
    placeholder: '',
    selectLabel: 'name',
    selectEntity: 'activity-category',
    selectValue: 'id',
    selectMultiple: false,
  },
  start_date_from: {
    label: 'global.date_range.from.label',
    inputType: 'datepicker',
    options: [],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__start-date-from--input',
    showError: true,
    errorClass: 'activities-activity__start-date-from--input-error',
    showHelp: false,
    helpClass: 'activities-activity__start-date-from--input-help',
    help: 'activities.activity.start_date_from.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__start-date-from--input-feedback',
    feedback: 'activities.activity.start_date_from.feedback',
    showLabel: true,
    labelClass: 'activities-activity__start-date-from--input-label',
    placeholder: 'start_date_from',
    showArrows: false,
  },
  start_date_to: {
    label: 'global.date_range.to.label',
    inputType: 'datepicker',
    options: [],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__start-date-to--input',
    showError: true,
    errorClass: 'activities-activity__start-date-to--input-error',
    showHelp: false,
    helpClass: 'activities-activity__start-date-to--input-help',
    help: 'activities.activity.start_date_to.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__start-date-to--input-feedback',
    feedback: 'activities.activity.start_date_to.feedback',
    showLabel: true,
    labelClass: 'activities-activity__start-date-to--input-label',
    placeholder: 'start_date_to',
    showArrows: false,
  },
  contact_id: {
    label: 'activities.enrollment.contact.label',
    inputType: 'entity-select',
    options: [],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__contact-id--input',
    showError: true,
    errorClass: 'activities-activity__contact-id--input-error',
    showHelp: false,
    helpClass: 'activities-activity__contact-id--input-help',
    help: 'activities.activity.contact_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__contact-id--input-feedback',
    feedback: 'activities.activity.contact_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__contact-id--input-label',
    placeholder: '',
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectValue: 'id',
    selectMultiple: false,
  },
  disciplines__id: {
    label: 'centers.resources.disciplines.label',
    inputType: 'entity-select',
    options: [],
    id: 'activities-activity__disciplines-id',
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__disciplines-id--input',
    showError: true,
    errorClass: 'activities-activity__disciplines-id--input-error',
    showHelp: false,
    helpClass: 'activities-activity__disciplines-id--input-help',
    help: 'activities.activity.disciplines_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__disciplines-id--input-feedback',
    feedback: 'activities.activity.disciplines_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity__disciplines-id--input-label',
    placeholder: '',
    selectLabel: 'name',
    selectEntity: 'discipline',
    selectValue: 'id',
    selectMultiple: false,
  },
  allow_multiple_enrollment: {
    label: 'activities.activity.allow_multiple_enrollment.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.yes',
        value: 1,
      },
      {
        text: 'global.no',
        value: 0,
      },
    ],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__allow-multiple-enrollment--input',
    showError: true,
    errorClass: 'activities-activity__allow-multiple-enrollment--input-error',
    showHelp: false,
    helpClass: 'activities-activity__allow-multiple-enrollment--input-help',
    help: 'activities.activity.allow_multiple_enrollment.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__allow-multiple-enrollment--input-feedback',
    feedback: 'activities.activity.allow_multiple_enrollment.feedback',
    showLabel: true,
    labelClass: 'activities-activity__allow-multiple-enrollment--input-label',
    placeholder: '',
  },
  published: {
    label: 'activities.activity.published.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.yes',
        value: 1,
      },
      {
        text: 'global.no',
        value: 0,
      },
    ],
    veeValidation: true,
    rules: [],
    fieldClass: 'activities-activity__published--input',
    showError: true,
    errorClass: 'activities-activity__published--input-error',
    showHelp: false,
    helpClass: 'activities-activity__published--input-help',
    help: 'activities.activity.published.help',
    showFeedback: true,
    feedbackClass: 'activities-activity__published--input-feedback',
    feedback: 'activities.activity.published.feedback',
    showLabel: true,
    labelClass: 'activities-activity__published--input-label',
    placeholder: '',
  },
};

export const activitySessionFields = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__id',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  center_id: {
    fieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__center-id',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
    labelClass: 'activities-activity-session__code--input-label',
    labelAttributes: {
      for: 'activities-activity-session__code',
    },
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.cancelled.label',
        value: 'cancelled',
      },
    ],
    id: 'global-activity-session__status',
    veeValidation: true,
    rules: ['required', 'in:active,cancelled'],
    warningRules: [],
    defaultValue: 'active',
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'cancelled',
        color: 'border-0 text-white bg-danger',
      },
    ],
    labelClass: 'activities-activity-session__status--input-label',
    labelAttributes: {
      for: 'activities-activity-session__status',
    },
  },
  name: {
    fieldPath: 'name',
    fieldReadPath: 'name',
    name: 'name',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__name',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    labelClass: 'activities-activity-session__name--input-label',
    labelAttributes: {
      for: 'activities-activity-session__name',
    },
  },
  team_name: {
    fieldPath: 'team_name',
    fieldReadPath: 'team_name',
    name: 'team_name',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__team_name',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    labelClass: 'activities-activity-session__team_name--input-label',
    labelAttributes: {
      for: 'activities-activity-session__team_name',
    },
  },
  can_be_cancelled: {
    fieldPath: 'can_be_cancelled',
    fieldReadPath: 'can_be_cancelled',
    name: 'can_be_cancelled',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__can_be_cancelled',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    labelClass: 'activities-activity-session__can_be_cancelled--input-label',
    labelAttributes: {
      for: 'activities-activity-session__can_be_cancelled',
    },
  },
  type: {
    fieldPath: 'type',
    fieldReadPath: 'type',
    name: 'type',
    inputType: 'select',
    options: [
      {
        text: 'activities.activity_session.type.game.label',
        value: 'game',
      },
      {
        text: 'activities.activity_session.type.training.label',
        value: 'training',
      },
      {
        text: 'activities.activity_session.type.collective_session.label',
        value: 'collective_session',
      },
      {
        text: 'activities.activity_session.type.other.label',
        value: 'other',
      },
    ],
    id: 'global-activity-session__session-type',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    labelClass: 'activities-activity-session__type--input-label',
    labelAttributes: {
      for: 'activities-activity-session__type',
    },
  },
  activity_id: {
    fieldPath: 'activity_id',
    errorFieldPath: 'activity_id',
    fieldReadPath: 'activity_id',
    name: 'activity_id',
    label: 'activities.activity_group.activity_id.label',
    id: 'activities-activity-group__activity-id',
    veeValidation: true,
    rules: ['required', 'exists:activities,id'],
    warningRules: [],
    fieldClass: 'activities-activity-group__activity-id--input',
    showError: true,
    errorClass: 'activities-activity-group__activity-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__activity-id--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.activity_id.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__activity-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.activity_id.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__activity-id--input-label',
    labelAttributes: {
      for: 'activities-activity-group__activity-id',
    },
  },
  activity: {
    fieldPath: 'activity',
    errorFieldPath: 'activity',
    fieldReadPath: 'activity',
    name: 'activity',
    label: 'activities.activity_group.activity.label',
    id: 'activities-activity-group__activity',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'activities-activity-group__activity--input',
    showError: true,
    errorClass: 'activities-activity-group__activity--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'activities-activity-group__activity--input-help',
    helpAttributes: [],
    help: 'activities.activity_group.activity.help',
    showFeedback: true,
    feedbackClass: 'activities-activity-group__activity--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_group.activity.feedback',
    showLabel: true,
    labelClass: 'activities-activity-group__activity--input-label',
    labelAttributes: {
      for: 'activities-activity-group__activity',
    },
    selectLabel: 'name',
    selectEntity: 'bpc-activity',
    selectMultiple: false,
    withTableSearch: true,
    displayConfigName: 'search',
    withNew: true,
    formConfigName: 'default',
  },
  responsibles: {
    fieldPath: 'responsibles',
    fieldReadPath: 'responsibles',
    name: 'responsibles',
    id: 'activities-activity-session__responsibles',
    rules: [],
    fieldAttributes: [],
    fieldClass: 'activities-activity-session__responsibles--input',
    errorClass: 'activities-activity-session__responsibles--input-error',
    errorAttributes: [],
    helpClass: 'activities-activity-session__responsibles--input-help',
    helpAttributes: [],
    help: 'activities.activity_session.responsibles.help',
    feedbackClass: 'activities-activity-session__responsibles--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity_session.responsibles.feedback',
    labelClass: 'activities-activity-session__responsibles--input-label',
    placeholder: 'activities.activity_session.responsible.label',
    selectValue: 'id',
    selectLabel: 'fullname',
    selectEntity: 'contact',
    selectMultiple: true,
    labelAttributes: {
      for: 'activities-activity-session__responsibles',
    },
  },
  short_description: {
    fieldPath: 'short_description',
    errorFieldPath: 'description',
    fieldReadPath: 'short_description',
    name: 'short_description',
    id: 'activities-activity-session__short-description',
    veeValidation: true,
    rules: ['nullable', 'string'],
    labelClass: 'activities-activity-session__short_description--input-label',
    labelAttributes: {
      for: 'activities-activity-session__short_description',
    },
  },
  description: {
    fieldPath: 'description',
    errorFieldPath: 'description',
    fieldReadPath: 'description',
    name: 'description',
    id: 'activities-activity-session__description',
    veeValidation: true,
    rules: ['nullable', 'string'],
    labelClass: 'activities-activity-session__description--input-label',
    labelAttributes: {
      for: 'activities-activity-session__description',
    },
  },
  date: {
    fieldPath: 'date',
    fieldReadPath: 'date',
    name: 'date',
    inputType: 'datepicker',
    id: 'global-activity-session__date',
    veeValidation: true,
    rules: ['required'],
    labelClass: 'activities-activity-session__date--input-label',
    labelAttributes: {
      for: 'activities-activity-session__date',
    },
  },
  start_time: {
    fieldPath: 'start_time',
    fieldReadPath: 'start_time',
    name: 'start_time',
    inputType: 'time',
    id: 'global-activity-session__start-time',
    veeValidation: true,
    rules: ['required'],
    labelClass: 'activities-activity-session__start_time--input-label',
    labelAttributes: {
      for: 'activities-activity-session__start_time',
    },
  },
  end_time: {
    fieldPath: 'end_time',
    fieldReadPath: 'end_time',
    name: 'end_time',
    inputType: 'time',
    id: 'global-activity-session__end-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    labelClass: 'activities-activity-session__end_time--input-label',
    labelAttributes: {
      for: 'activities-activity-session__end_time',
    },
  },
  time_range: {
    fieldPath: 'time_range',
    fieldReadPath: 'time_range',
    errorFieldPath: 'time_range',
    inputType: 'timeRange',
    id: 'global-activity-session__time_range',
    veeValidation: true,
    rules: ['nullable'],
    labelClass: 'activities-activity-session__time_range--input-label',
    labelAttributes: {
      for: 'activities-activity-session__time_range',
    },
  },
  min_participants: {
    fieldPath: 'min_participants',
    errorFieldPath: 'min_participants',
    fieldReadPath: 'min_participants',
    name: 'min_participants',
    id: 'activities-activity-session__min-participants',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    fieldAttributes: {
      type: 'number',
      step: '1',
    },
    labelClass: 'activities-activity-session__min_participants--input-label',
    labelAttributes: {
      for: 'activities-activity-session__min_participants',
    },
  },
  max_participants: {
    fieldPath: 'max_participants',
    errorFieldPath: 'max_participants',
    fieldReadPath: 'max_participants',
    name: 'max_participants',
    id: 'activities-activity-session__max-participants',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    fieldAttributes: {
      type: 'number',
      step: '1',
    },
    labelClass: 'activities-activity-session__max_participants--input-label',
    labelAttributes: {
      for: 'activities-activity-session__max_participants',
    },
  },
  attendees_start_date_time: {
    fieldPath: 'attendees_start_date_time',
    fieldReadPath: 'attendees_start_date_time',
    name: 'attendees_start_date_time',
    inputType: 'datetimepicker',
    id: 'global-activity-session__attendees-start-date-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    labelClass: 'activities-activity-session__attendees_start_date_time--input-label',
    labelAttributes: {
      for: 'activities-activity-session__attendees_start_date_time',
    },
  },
  attendees_end_date_time: {
    fieldPath: 'attendees_end_date_time',
    fieldReadPath: 'attendees_end_date_time',
    name: 'attendees_end_date_time',
    inputType: 'datetimepicker',
    id: 'global-activity-session__attendees-end-date-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    labelClass: 'activities-activity-session__attendees_end_date_time--input-label',
    labelAttributes: {
      for: 'activities-activity-session__attendees_end_date_time',
    },
  },
  with_waiting_list: {
    fieldPath: 'with_waiting_list',
    errorFieldPath: 'with_waiting_list',
    fieldReadPath: 'with_waiting_list',
    name: 'with_waiting_list',
    id: 'activities-activity-session__with-waiting-list',
    veeValidation: true,
    rules: ['boolean'],
    labelClass: 'activities-activity-session__with_waiting_list--input-label',
    labelAttributes: {
      for: 'activities-activity-session__with_waiting_list',
    },
  },
  cancel_reason: {
    fieldPath: 'cancel_reason',
    fieldReadPath: 'cancel_reason',
    name: 'cancel_reason',
    inputType: 'input',
    options: [
      {
        text: 'activities.cancel_reasons.responsible.title',
        value: 'responsible',
      },
      {
        text: 'activities.cancel_reasons.under_min.title',
        value: 'under_min',
      },
      {
        text: 'activities.cancel_reasons.other',
        value: 'other',
      },
    ],
    id: 'global-activity-session__cancel-reason',
    veeValidation: true,
    rules: ['nullable', 'string'],
    warningRules: [],
    labelClass: 'activities-activity-session__cancel_reason--input-label',
    labelAttributes: {
      for: 'activities-activity-session__cancel_reason',
    },
  },
  cancel_reason_description: {
    fieldPath: 'cancel_reason_description',
    errorFieldPath: 'cancel_reason_description',
    fieldReadPath: 'cancel_reason_description',
    name: 'cancel_reason_description',
    id: 'activities-activity-session__cancel-reason-description',
    veeValidation: true,
    rules: ['nullable', 'string'],
    labelClass: 'activities-activity-session__cancel_reason_description--input-label',
    labelAttributes: {
      for: 'activities-activity-session__cancel_reason_description',
    },
  },
  // game details related fields
  opponent_name: {
    fieldPath: 'opponent_name',
    fieldReadPath: 'opponent_name',
    name: 'opponent_name',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__opponent-name',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    labelClass: 'activities-activity-session__opponent_name--input-label',
    labelAttributes: {
      for: 'activities-activity-session__opponent_name',
    },
  },
  away: {
    fieldPath: 'away',
    errorFieldPath: 'away',
    fieldReadPath: 'away',
    name: 'away',
    id: 'activities-activity-session__away',
    veeValidation: true,
    rules: ['boolean'],
    labelClass: 'activities-activity-session__away--input-label',
    labelAttributes: {
      for: 'activities-activity-session__away',
    },
  },
  venue_name: {
    fieldPath: 'venue_name',
    fieldReadPath: 'venue_name',
    name: 'venue_name',
    inputType: 'input',
    options: [],
    id: 'global-activity-session__venue-name',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    labelClass: 'activities-activity-session__venue_name--input-label',
    labelAttributes: {
      for: 'activities-activity-session__venue_name',
    },
  },
  venue_address: {
    fieldPath: 'venue_address',
    errorFieldPath: 'venue_address',
    fieldReadPath: 'venue_address',
    name: 'venue_address',
    id: 'activities-activity-session__venue-address',
    veeValidation: true,
    rules: ['nullable'],
    labelClass: 'activities-activity-session__venue_address--input-label',
    labelAttributes: {
      for: 'activities-activity-session__venue_address',
    },
  },
  meeting_time: {
    fieldPath: 'meeting_time',
    fieldReadPath: 'meeting_time',
    name: 'meeting_time',
    inputType: 'time',
    id: 'global-activity-session__meeting-time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    labelClass: 'activities-activity-session__meeting_time--input-label',
    labelAttributes: {
      for: 'activities-activity-session__meeting_time',
    },
  },
  meeting_address: {
    fieldPath: 'meeting_address',
    errorFieldPath: 'meeting_address',
    fieldReadPath: 'meeting_address',
    name: 'meeting_address',
    id: 'activities-activity-session__meeting-address',
    veeValidation: true,
    rules: ['nullable'],
    labelClass: 'activities-activity-session__meeting_address--input-label',
    labelAttributes: {
      for: 'activities-activity-session__meeting_address',
    },
  },
  team_score: {
    fieldPath: 'team_score',
    errorFieldPath: 'team_score',
    fieldReadPath: 'team_score',
    name: 'team_score',
    id: 'activities-activity-session__team-score',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    fieldAttributes: {
      type: 'number',
      step: '0.5',
    },
    labelClass: 'activities-activity-session__team_score--input-label',
    labelAttributes: {
      for: 'activities-activity-session__team_score',
    },
  },
  opponent_score: {
    fieldPath: 'opponent_score',
    errorFieldPath: 'opponent_score',
    fieldReadPath: 'opponent_score',
    name: 'opponent_score',
    id: 'activities-activity-session__opponent-score',
    veeValidation: true,
    rules: ['nullable', 'numeric'],
    fieldAttributes: {
      type: 'number',
      step: '0.5',
    },
    labelClass: 'activities-activity-session__opponent_score--input-label',
    labelAttributes: {
      for: 'activities-activity-session__opponent_score',
    },
  },
  score_details: {
    fieldPath: 'score_details',
    errorFieldPath: 'score_details',
    fieldReadPath: 'score_details',
    name: 'score_details',
    id: 'activities-activity-session__score-details',
    veeValidation: true,
    rules: ['nullable'],
    labelClass: 'activities-activity-session__score_details--input-label',
    labelAttributes: {
      for: 'activities-activity-session__score_details',
    },
  },
};
